import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ServiceNewsletterService } from './service-newsletter.service';

@Component({
  selector: 'app-newsletter',
  imports: [ReactiveFormsModule],
  templateUrl: './newsletter.component.html',
  styleUrl: './newsletter.component.scss',
  standalone: true
})
export class NewsletterComponent implements OnInit {
  form: FormGroup;

  response: any = {};

  constructor(
    private fb: FormBuilder,
    private newsletterService: ServiceNewsletterService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }
  submit(form: FormGroup) {
    if (form.invalid) {
      alert('error');
      return false;
    }
    this.newsletterService.postNewsletter(form.value).subscribe((res) => {
      if (res?.success) {
        this.response = res;
      }
    });

    return false;
  }
  get email() {
    return this.form.get('name');
  }
}
